// src/components/HoneyBackground.jsx
import React from "react";

 let drop1 = "../assets/honey/1.png";      // first image (big blob)
let drop2 = "/assets/honey/2.png";      // second image (4 blobs)
let comb1 = "/assets/honey/3.png";   // third image (single comb)
let comb2 = "/assets/honey/4.png";    // fourth image (stack comb)



const HoneyBackground = () => {
  return (
    <>
      {/* Desktop background assets */}
      <img
        src={drop1}
        alt="Honey drop"
        className="
          hidden md:block
          pointer-events-none select-none
          absolute -left-12 top-40
          w-72 lg:w-96
          opacity-95
        "
      />

      {/* <img
        src={drop2}
        alt="Honey drops"
        className="
          hidden md:block
          pointer-events-none select-none
          absolute bottom-8 left-1/4
          w-[26rem] lg:w-[32rem]
          opacity-20
        "
      /> */}

      <img
        src={comb1}
        alt="Honeycomb piece"
        className="
          hidden md:block
          pointer-events-none select-none
          absolute top-5 -right-60
          w-58 lg:w-94
          opacity-28
        "
      />

      {/* <img
        src={drop1}
        alt="Honeycomb stack"
        className="
          hidden md:block
          pointer-events-none select-none
          absolute bottom-0 right-0
          w-72 lg:w-[24rem]
          opacity-15
        "
      /> */}

      {/* Mobile background version (simplified for readability) */}
      <img
        src={drop1}
        alt="Honey drop"
        className="
          md:hidden
          pointer-events-none select-none
          absolute top-25 left-20
          w-52
          opacity-65
        "
      />

 {/* <img
        src={drop2}
        alt="Honey drop"
        className="
          md:hidden
          pointer-events-none select-none
          absolute bottom-45 -right-15
          w-52
          opacity-55
        "
      /> */}
      <img
        src={drop1}
        alt="Honey comb"
        className="
          md:hidden
        rotate-187

          pointer-events-none select-none
          absolute -bottom-10 -right-10
          w-65
          opacity-95
        "
      />
    </>
  );
};

export default HoneyBackground;
